import script from "./redes.vue?vue&type=script&setup=true&lang=js"
export * from "./redes.vue?vue&type=script&setup=true&lang=js"

import "./redes.vue?vue&type=style&index=0&id=1b48a0ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b48a0ab"]])

export default __exports__